import React from "react";

export default function AnswerView({ answer }) {
  return (
    <section className="answer-panel info-panel">
      <div className="section-kicker">Response</div>
      <h2>Grounded output</h2>
      {answer ? (
        <>
          <p className="answer-text">{answer.answer}</p>
          <div className="answer-meta">
            <span>{answer.model_id}</span>
            <span>{answer.latency_ms} ms</span>
          </div>
        </>
      ) : (
        <p className="answer-placeholder">
          The site is live. Attach a document, ask a question, and inspect the retrieved evidence below.
        </p>
      )}
    </section>
  );
}
